import Flickity from 'flickity-imagesloaded';
import debounce from 'lodash/debounce';
import raf from 'raf';

export default class SocialQuotes {
  constructor() {
    this.$el = document.querySelector('.c-social-quotes');
    if (!this.$el) return;

    // DOM
    this.$carouselElement = this.$el.querySelector('.c-social-quotes__carousel');

    // Functions
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);

    // Variables
    this.requestId = null;
    this.minWidth = 1025;

    // Events
    window.addEventListener('resize', debounce(this.onResize, 250).bind(this));

    // Create the carousel
    this.createCarousel();
  }

  /**
   * @function onResize
   * Fired on window resize
   */
  onResize() {
    if (window.innerWidth < this.minWidth && this.carousel) {
      this.pause();
      this.carousel.destroy();
    } else {
      this.createCarousel();
    }
  }

  /**
   * @function createCarousel
   */
  createCarousel() {
    const $el = this.$carouselElement;

    if (this.$carouselElement && window.innerWidth >= this.minWidth) {
      this.carousel = new Flickity(this.$carouselElement, {
        cellAlign: 'center',
        contain: true,
        imagesLoaded: true,
        pageDots: false,
        percentPosition: false,
        prevNextButtons: false,
        wrapAround: true,
        paused: true,
        on: {
          ready() {
            const $groups = $el.querySelectorAll('.c-social-quotes__group');

            $groups.forEach(($group) => {
              $group.style.height = '100%';
            });
          },
        },
      });

      this.play();
    }
  }

  /**
   * @function play
   * Plays the marquee
   */
  play() {
    if (!this.carousel) return;

    // Set the decrement of position x
    this.carousel.x = this.carousel.x - 0.5;

    // Settle position into the slider
    this.carousel.settle(this.carousel.x);

    // Set the requestId to the local variable
    this.requestId = raf(this.play);
  }

  /**
   * @function pause
   * Pauses the marquee
   */
  pause() {
    if (!this.requestId || !this.carousel) return;

    // Cancel the animation
    raf.cancel(this.requestId);

    // Reset the this.requestId for the next animation.
    this.requestId = null;
  }
}
